import { Timestamp } from "firebase/firestore";

export const evaluationToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    // Cálculo proativo de nota
    let totalScore = 0;
    if (data.grades && data.grades.length > 0) {
        data.grades.forEach(g => totalScore += Number(g.score));
    }
    const averageScore = data.grades?.length ? (totalScore / data.grades.length) : 0;

    const payload = {
        idTenant,
        idMember: data.idMember,
        memberName: data.memberName,
        memberPhone: data.memberPhone,
        memberEmail: data.memberEmail,
        memberPhotoUrl: data.memberPhotoUrl,
        
        idEmployee: data.idEmployee,
        employeeName: data.employeeName,
        employeeEmail: data.employeeEmail,
        employeePhone: data.employeePhone,
        employeePhotoUrl: data.employeePhotoUrl,
        
        idActivity: data.idActivity,
        activityName: data.activityName,
        
        idLevel: data.idLevel,
        levelName: data.levelName,

        date: typeof data.date === 'string'
            ? data.date
            : (data.date instanceof Date ? data.date.toISOString().split('T')[0] : null),
        
        observations: data.observations,
        
        // Vetor de Mapas simples do Firestore
        grades: data.grades || [],
        
        totalScore: totalScore,
        averageScore: Number(averageScore.toFixed(2)),

        idEvent: data.idEvent,
        eventName: data.eventName,
        status: data.status,

        // Controle de XP (prevenção de duplicidade)
        xpTopicAwarded: data.xpTopicAwarded,
        xpPassAwarded: data.xpPassAwarded,
        xpTopicTotal: Number(data.xpTopicTotal),
        progressPercent: Number(data.progressPercent),

        // Dados da avaliação por objetivo/tópico
        objectives: data.objectives || [],
        idClass: data.idClass,
        idTeacher: data.idTeacher,
        teacherName: data.teacherName,
        teacherEmail: data.teacherEmail,
        teacherPhone: data.teacherPhone,
        teacherPhotoUrl: data.teacherPhotoUrl,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

export const evaluationFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        date: data.date?.toDate ? data.date.toDate().toISOString().split('T')[0] : data.date,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
